import React, { forwardRef, useEffect } from 'react';

import classNames from 'classnames';
import usePlayersContext from '../hooks/usePlayersContext';
import useEpisodePlayersContext from '../../../hooks/useEpisodePlayersContext';

const PlayPauseButton = forwardRef(
    (
        { setIsPlaying, isSliderProgress, setIsSliderProgress, handleClick, loadAudioFile, updateDuration, episodeId },
        ref
    ) => {
        const {
            setClickedButtonIndex,
            clickedButtonIndex,
            setActiveIndex,
            activeEpisodeIndex,
            setScrollDisabled,
            nextVideoPlay,
            setPreviousAudio,
            previousAudio,
        } = useEpisodePlayersContext();
        const { episodeIndex } = usePlayersContext();
        const { current } = ref;

        useEffect(() => {
            if (nextVideoPlay === episodeId) {
                togglePlay();
            }
        }, [nextVideoPlay]);

        useEffect(() => {
            if (current && previousAudio === episodeId) {
                setIsPlaying(false);
                current.pause();
            }
        }, [previousAudio]);

        const togglePlay = async () => {
            let audio = current;

            if (!current) {
                setIsSliderProgress(true);
                audio = await loadAudioFile();
            }

            const { paused, currentTime, duration } = audio;
            updateDuration(Math.ceil(duration));
            setIsPlaying(true);

            if (Math.round(currentTime) === Math.round(duration)) {
                current.currentTime = 0;
            }

            if (paused) {
                if (episodeIndex !== activeEpisodeIndex) {
                    setPreviousAudio(activeEpisodeIndex);
                }

                setScrollDisabled(false);
                setActiveIndex(episodeIndex);
                handleClick();
                audio.play();
            } else {
                setScrollDisabled(true);
                setIsPlaying(false);
                audio.pause();
                setClickedButtonIndex(null);
            }
        };

        const isBtnPaused = clickedButtonIndex === episodeIndex || (current && !current?.paused);

        const buttonClass = classNames('player-app__btn-play-pause', {
            'episode-player-downloading': isSliderProgress === true,
            'episode-player-pause': isBtnPaused,
            'episode-player-play': !isBtnPaused,
        });

        return (
            <button className={buttonClass} onClick={togglePlay}>
                {isBtnPaused ? (
                    <span className="player-app__btn-play-pause-pause" />
                ) : (
                    <svg
                        className="player-app__btn-play-pause-play"
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="24" cy="24" r="24" fill="#281541" />
                        <path
                            d="M34 25.7321C35.3333 24.9623 35.3333 23.0377 34 22.2679L20.5 14.4737C19.1667 13.7039 17.5 14.6662 17.5 16.2058V31.7942C17.5 33.3338 19.1667 34.2961 20.5 33.5263L34 25.7321Z"
                            fill="white"
                        />
                    </svg>
                )}
                <span className="player-app__btn-play-pause-loading">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </button>
        );
    }
);

export default PlayPauseButton;
